module.exports = __webpack_public_path__ + "static/media/incomplete-team-example.358523f9.jpg";